// @flow

import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import { Parallax } from 'react-scroll-parallax'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { Container } from '../../../components/basic/Grid'
import CaseList from '../CaseList'
import baseStyles from './CaseInfo.scss'

type Props = {
  ...StyleProps,
  title?: string,
  list?: Array<string>,
  text?: string,
  richText?: string,
  img: string
}

const CaseInfo = ({ styles, title, list, text, richText, img }: Props) => (
  <div className={styles.root}>
    <Container className={styles.container} fluid>
      <div className={styles.imageWrap}>
        <ScrollAnimation animateIn="fadeInRight" animateOnce>
          <Parallax y={[-7, 7]} className={styles.parallaxWrapper}>
            <div className={styles.imageContainer}>{img}</div>
          </Parallax>
        </ScrollAnimation>
      </div>
      <div className={styles.content}>
        <CaseList title={title} text={text} richText={richText} list={list} styles={styles.list} />
      </div>
    </Container>
  </div>
)

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseInfo)
